import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'acl-register-successful',
  standalone: false,
  templateUrl: './register-successful.component.html',
  styleUrl: './register-successful.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterSuccessfulComponent {
  @Output() readonly slideTo = new EventEmitter();

  private readonly router = inject(Router);

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
